import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { IRootState } from "../store/reducers";
import "./AppContainer.scss";
import AppSideNav from "./AppSideNav/AppSideNav";

export interface IAppContainerProps extends StateProps, DispatchProps, RouteComponentProps {}

export class AppContainer extends React.Component<IAppContainerProps> {
  render() {
    return (
      <section className="app-container">
        <AppSideNav />

        <main className="main-container">{this.props.children}</main>
      </section>
    );
  }
}

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = {};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AppContainer));
